<div class="container">
  <div class="title-online">Members</div>
  @if(onlineMembers.length) {
  <div class="slider">
    <div class="slide-track"
      [ngStyle]="{ 'animation-play-state': playAnimation && onlineMembers.length > 30 ? 'running' : 'paused' }">
      <a [routerLink]="['/profile', user.appUser.referralCode]" class="slide"
        [ngbTooltip]="user.appUser?.profileCharacterName || 'Unknown'"
        *ngFor="let user of onlineMembers; let i = index">
        <img loading="lazy" [src]="local.checkImageProfile(user.appUser)" alt="Image" />
      </a>
    </div>
    @if(onlineMembers.length > 30) {
    <div class="play" (click)="playAnimation = !playAnimation">
      @if(playAnimation){
      <i class="fa-solid fa-pause"></i>
      }@else {
      <i class="fa-solid fa-play"></i>
      }
    </div>
    }
  </div>
  }@else {
  <div class="no-online">No Members available.</div>
  }
  <!-- @if(onlineMembers.length) {
  <div class="online-images">
    <div class="square-container">
      <div *ngFor="let user of onlineMembers; let i = index" class="moving-image" (click)="showOnlineMembers = !showOnlineMembers" [ngStyle]="{ 'animation-delay': i * 1 + 's', 'animation-play-state': playAnimation && onlineMembers.length > 30 ? 'running' : 'paused' }">
        <img loading="lazy" [src]="imgUrl + user.appUser.profileCharacterImageFile" alt="Image" />
      </div>
    </div>
    @if(onlineMembers.length > 30) {
    <div class="play" (click)="playAnimation = !playAnimation">
      @if(playAnimation){
      <i class="fa-solid fa-pause"></i>
      }@else {
      <i class="fa-solid fa-play"></i>
      }
    </div>
    }
  </div>
  } -->
  <div class="online-members">
    <!-- <div class="online-members__title"><span class="green-dot"></span> Members</div> -->
    <div class="online-members__list row">
      <!-- <div *ngIf="onlineMembers.length < 1" class="col-12 text-center">No Members available.</div> -->
      <div *ngFor="let user of aroundMembers; let i = index" class="online-members__list--item col-md-6">
        <div class="online-members__list--item--wrapper">
          <img loading="lazy" [src]="local.checkImageProfile(user.appUser)" alt="Image"
            [routerLink]="['/profile', user.appUser.referralCode]" />
          <div class="d-flex flex-column">
            <div class="d-flex">
              <div class="online-members__list--item--wrapper__name"
                [routerLink]="['/profile', user.appUser.referralCode]">
                {{ user.appUser?.profileCharacterName || "Unknown" }}
              </div>
              <div class="ml-2 my-auto">
                <span *ngIf="user.isOnline" class="badge-whatsapp">Online</span>
              </div>
            </div>
            <div class="d-flex flex-wrap">
              <span class="item"> <i class="fa-regular fa-clock"></i> Since {{ user.appUser?.created || "N/A" }} </span>
              <div>
                <span class="item"> <i class="fa-regular fa-square-plus"></i> {{ user.appUserSupportsCount || 0 }}
                  Support </span>
                <span class="item" *ngIf="user.appUser?.region"> <i class="fa-solid fa-earth-asia"></i> {{
                  user.appUser.region.split("|")[1] || "Unknown" }} </span>
              </div>
            </div>
          </div>
          <div class="ml-auto">
            <div style="z-index: 100; cursor: pointer;">
              <span class="icon-list" aria-hidden="true" id="profileMenu" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
                <i class="fa-solid fa-ellipsis-v"></i>
              </span>
              <div class="dropdown-menu" aria-labelledby="profileMenu">
                <span class="dropdown-item" (click)="handleReport(user.appUser)">Report</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>